type DateCollector = {
  days: string[],
  months: string[],
  years: string[],
}

const days = Array.from({ length: 31 }, (_, index) => `${index + 1}`);

const months = Array.from({ length: 12 }, (_, index) => `${index + 1}`);

const currentDate = new Date();
const yearsLength = currentDate.getFullYear() - 1900;
const years = Array.from({ length: yearsLength }, (_, index) => `${index + 1900}`);

export const dateCollector: DateCollector = {
  days: days,
  months: months,
  years: years
};
